module.exports = __webpack_public_path__ + "img/mempercepat-pengajuan-kredit.602e9551.svg";